module.exports = __webpack_public_path__ + "static/media/banner-2.af6fde21.mp4";